import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getEmployees } from "../../../lib/getEmployees";
import AllEmployeeTable from "./AllEmployeeTable";

const AllEmployees = () => {
  const [employeeList, setEmployeeList] = useState([]);
  const navigate = useNavigate();

  const storage = useMemo(() => {
    return JSON.parse(window.localStorage.getItem("userDetails"));
  }, []);

  const refreshEmployeeList = useCallback(() => {
    getEmployees().then((res) => {
      if (res?.status === 200 && Array.isArray(res.data)) {
        setEmployeeList(res.data);
      }
    });
  }, [storage]);

  useEffect(() => {
    if (storage?.role === "superadmin" || storage?.role === "admin_empleados") {
      refreshEmployeeList();
    } else {
      navigate("/");
    }
  }, [navigate, storage?.role, refreshEmployeeList]);

  return (
    <>
      <h2>Listado de Empleados</h2>
      <AllEmployeeTable
        data={employeeList}
        setEmployeeList={setEmployeeList}
        refreshEmployeeList={refreshEmployeeList}
      />
    </>
  );
};

export default AllEmployees;
